import produce from "immer";
import { MarketCampaignActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialMarketCampaignState } from "./marketCampaign.types";
import {
  CLEAR_MARKET_CAMPAIGN_STATE,
  FETCH_CAMPAIGN_RULE_TEMPLATES_FAILED,
  FETCH_CAMPAIGN_RULE_TEMPLATES_PROGRESS,
  FETCH_CAMPAIGN_RULE_TEMPLATES_SUCCESS,
  FETCH_MARKETING_CAMPAIGN_LOGS_FAILED,
  FETCH_MARKETING_CAMPAIGN_LOGS_PROGRESS,
  FETCH_MARKETING_CAMPAIGN_LOGS_SUCCESS,
  FETCH_MARKET_CAMPAIGN_AUDIENCE_LIST_PROGRESS,
  FETCH_MARKET_CAMPAIGN_AUDIENCE_LIST_SUCCESS,
  FETCH_MARKET_CAMPAIGN_AUDIENCE_LIST_FAILED,
  FETCH_MARKET_CAMPAIGN_CHANNEL_LIST_PROGRESS,
  FETCH_MARKET_CAMPAIGN_CHANNEL_LIST_SUCCESS,
  FETCH_MARKET_CAMPAIGN_CHANNEL_LIST_FAILED,
  FETCH_MARKET_CAMPAIGN_LIST_PROGRESS,
  FETCH_MARKET_CAMPAIGN_LIST_SUCCESS,
  FETCH_MARKET_CAMPAIGN_LIST_FAILED,
  FETCH_MARKET_CAMPAIGN_PROGRESS,
  FETCH_MARKET_CAMPAIGN_SUCCESS,
  FETCH_MARKET_CAMPAIGN_FAILED,
  FETCH_QUICK_SEND_CAMPAIGN_LIST_PROGRESS,
  FETCH_QUICK_SEND_CAMPAIGN_LIST_SUCCESS,
  FETCH_QUICK_SEND_CAMPAIGN_LIST_FAILED,
  FETCH_MARKET_CAMPAIGN_CRON_SCHEDULERS_PROGRESS,
  FETCH_MARKET_CAMPAIGN_CRON_SCHEDULERS_SUCCESS,
  FETCH_MARKET_CAMPAIGN_CRON_SCHEDULERS_FAILED,
  FETCH_CAMPAIGN_SQL_QUERY_RESULT_PROGRESS,
  FETCH_CAMPAIGN_SQL_QUERY_RESULT_SUCCESS,
  FETCH_CAMPAIGN_SQL_QUERY_RESULT_FAILED,
  FETCH_MARKET_CAMPAIGN_AUDIENCE_PROGRESS,
  FETCH_MARKET_CAMPAIGN_AUDIENCE_SUCCESS,
  FETCH_MARKET_CAMPAIGN_AUDIENCE_FAILED,
  FETCH_ALL_MARKET_CAMPAIGN_AUDIENCE_LIST_PROGRESS,
  FETCH_ALL_MARKET_CAMPAIGN_AUDIENCE_LIST_SUCCESS,
  FETCH_ALL_MARKET_CAMPAIGN_AUDIENCE_LIST_FAILED,
  SAVE_MARKET_CAMPAIGN_AUDIENCE_LIST_PROGRESS,
  SAVE_MARKET_CAMPAIGN_AUDIENCE_LIST_SUCCESS,
  SAVE_MARKET_CAMPAIGN_AUDIENCE_LIST_FAILED,
  FETCH_MARKET_CAMPAIGN_DRAFT_STEPS_PROGRESS,
  FETCH_MARKET_CAMPAIGN_DRAFT_STEPS_SUCCESS,
  FETCH_MARKET_CAMPAIGN_DRAFT_STEPS_FAILED,
  FETCH_AUDIENCE_LIST_COLUMNS_PROGRESS,
  FETCH_AUDIENCE_LIST_COLUMNS_SUCCESS,
  FETCH_AUDIENCE_LIST_COLUMNS_FAILED,
  UPSERT_AUDIENCE_LIST_COLUMN_PROGRESS,
  UPSERT_AUDIENCE_LIST_COLUMN_SUCCESS,
  UPSERT_AUDIENCE_LIST_COLUMN_FAILED,
  FETCH_SINGLE_MARKET_CAMPAIGN_PROGRESS,
  FETCH_SINGLE_MARKET_CAMPAIGN_SUCCESS,
  FETCH_SINGLE_MARKET_CAMPAIGN_FAILED,
  CLEAR_DRAFT_STEP_STATE,
} from "./marketCampaignActions";
import { LoadState } from "../../constants/enums";

export const marketCampaignReducer = (
  state: IStoreState["marketCampaign"] = initialMarketCampaignState,
  action: MarketCampaignActions,
) => {
  switch (action.type) {
    case FETCH_MARKET_CAMPAIGN_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.InProgress;
        draftState.marketCampainBasicInfo.list = [];
        draftState.marketCampainBasicInfo.totalRecords = 0;
        draftState.marketCampainBasicInfo.currentRecords = 0;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_LIST_SUCCESS: {
      const { list, totalRecords, currentRecords, meta } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.Loaded;
        draftState.marketCampainBasicInfo.list = list;
        draftState.marketCampainBasicInfo.totalRecords = totalRecords;
        draftState.marketCampainBasicInfo.currentRecords = currentRecords;
        draftState.marketCampainBasicInfo.meta = meta;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.Failed;
        draftState.marketCampainBasicInfo.list = [];
        draftState.marketCampainBasicInfo.totalRecords = 0;
        draftState.marketCampainBasicInfo.currentRecords = 0;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.InProgress;
        draftState.marketCampainBasicInfo.data =
          initialMarketCampaignState["marketCampainBasicInfo"].data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.Loaded;
        draftState.marketCampainBasicInfo.data = data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.Failed;
        draftState.marketCampainBasicInfo.error = errorMessage;
      });
      return newState;
    }

    case FETCH_CAMPAIGN_RULE_TEMPLATES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignRuleTemplate.loading = LoadState.InProgress;
        draftState.marketCampaignRuleTemplate.list = [];
      });
      return newState;
    }
    case FETCH_CAMPAIGN_RULE_TEMPLATES_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignRuleTemplate.loading = LoadState.Loaded;
        draftState.marketCampaignRuleTemplate.list = list;
      });
      return newState;
    }
    case FETCH_CAMPAIGN_RULE_TEMPLATES_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignRuleTemplate.loading = LoadState.Failed;
        draftState.marketCampaignRuleTemplate.list = [];
      });
      return newState;
    }
    case FETCH_MARKETING_CAMPAIGN_LOGS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignLogs.loading = LoadState.InProgress;
        draftState.marketCampaignLogs.list = [];
      });
      return newState;
    }
    case FETCH_MARKETING_CAMPAIGN_LOGS_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignLogs.loading = LoadState.Loaded;
        draftState.marketCampaignLogs.list = list;
      });
      return newState;
    }
    case FETCH_MARKETING_CAMPAIGN_LOGS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignLogs.loading = LoadState.Failed;
        draftState.marketCampaignLogs.list = [];
      });
      return newState;
    }

    // Market Campaign Audience List
    case FETCH_MARKET_CAMPAIGN_AUDIENCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.InProgress;
        draftState.marketCampaignAudience.list = [];
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_AUDIENCE_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.Loaded;
        draftState.marketCampaignAudience.list = list;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_AUDIENCE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.Failed;
        draftState.marketCampaignAudience.list = [];
      });
      return newState;
    }

    // Market Campaign Channel List
    case FETCH_MARKET_CAMPAIGN_CHANNEL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignChannel.loading = LoadState.InProgress;
        draftState.marketCampaignChannel.data =
          initialMarketCampaignState.marketCampaignChannel.data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_CHANNEL_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignChannel.loading = LoadState.Loaded;
        draftState.marketCampaignChannel.data = data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_CHANNEL_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignChannel.loading = LoadState.Failed;
        draftState.marketCampaignChannel.data =
          initialMarketCampaignState.marketCampaignChannel.data;
      });
      return newState;
    }

    // Quick Send Campaign List
    case FETCH_QUICK_SEND_CAMPAIGN_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignQuickSend.loading = LoadState.InProgress;
        draftState.marketCampaignQuickSend.list = [];
      });
      return newState;
    }
    case FETCH_QUICK_SEND_CAMPAIGN_LIST_SUCCESS: {
      const { list, headers, totalRecords } = action.payload;

      const newState = produce(state, (draftState) => {
        draftState.marketCampaignQuickSend.loading = LoadState.Loaded;
        draftState.marketCampaignQuickSend.list = list;
        draftState.marketCampaignQuickSend.headers = headers;
        draftState.marketCampaignQuickSend.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_QUICK_SEND_CAMPAIGN_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignQuickSend.loading = LoadState.Failed;
        draftState.marketCampaignQuickSend.list = [];
      });
      return newState;
    }

    // Market Campaign Cron Schedulers
    case FETCH_MARKET_CAMPAIGN_CRON_SCHEDULERS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignCronScheduler.loading = LoadState.InProgress;
        draftState.marketCampaignCronScheduler.data =
          initialMarketCampaignState.marketCampaignCronScheduler.data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_CRON_SCHEDULERS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignCronScheduler.loading = LoadState.Loaded;
        draftState.marketCampaignCronScheduler.data = data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_CRON_SCHEDULERS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignCronScheduler.loading = LoadState.Failed;
        draftState.marketCampaignCronScheduler.data =
          initialMarketCampaignState.marketCampaignCronScheduler.data;
      });
      return newState;
    }

    case FETCH_CAMPAIGN_SQL_QUERY_RESULT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.campaignSqlQueryResult.loading = LoadState.InProgress;
        draftState.campaignSqlQueryResult.list = [];
        draftState.campaignSqlQueryResult.error = null;
      });
      return newState;
    }
    case FETCH_CAMPAIGN_SQL_QUERY_RESULT_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.campaignSqlQueryResult.loading = LoadState.Loaded;
        draftState.campaignSqlQueryResult.list = list;
        draftState.campaignSqlQueryResult.error = null;
      });
      return newState;
    }
    case FETCH_CAMPAIGN_SQL_QUERY_RESULT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.campaignSqlQueryResult.loading = LoadState.Failed;
        draftState.campaignSqlQueryResult.list = [];
        draftState.campaignSqlQueryResult.error = errorMessage;
      });
      return newState;
    }

    case FETCH_MARKET_CAMPAIGN_AUDIENCE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.dataLoading = LoadState.InProgress;
        draftState.marketCampaignAudience.data =
          initialMarketCampaignState.marketCampaignAudience.data;
        draftState.marketCampaignAudience.error = null;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_AUDIENCE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.dataLoading = LoadState.Loaded;
        draftState.marketCampaignAudience.data = data;
        draftState.marketCampaignAudience.error = null;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_AUDIENCE_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.dataLoading = LoadState.Failed;
        draftState.marketCampaignAudience.data =
          initialMarketCampaignState.marketCampaignAudience.data;
      });
      return newState;
    }

    //All  Market Campaign Audience List
    case FETCH_ALL_MARKET_CAMPAIGN_AUDIENCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.InProgress;
        draftState.marketCampaignAudience.list = [];
      });
      return newState;
    }

    case FETCH_ALL_MARKET_CAMPAIGN_AUDIENCE_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.Loaded;
        draftState.marketCampaignAudience.list = list;
        draftState.marketCampaignAudience.totalRecords = totalRecords;
        // Also update the data.audience_list if needed
        if (list.length > 0 && list[0].audience_list) {
          draftState.marketCampaignAudience.data.audience_list =
            list[0].audience_list;
        }
      });
      return newState;
    }
    case FETCH_ALL_MARKET_CAMPAIGN_AUDIENCE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.Failed;
        draftState.marketCampaignAudience.list = [];
      });
      return newState;
    }

    // Save All  Market Campaign Audience List

    case SAVE_MARKET_CAMPAIGN_AUDIENCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.InProgress;
      });
      return newState;
    }
    case SAVE_MARKET_CAMPAIGN_AUDIENCE_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.Loaded;
        draftState.marketCampaignAudience.list.unshift(data);
      });
      return newState;
    }
    case SAVE_MARKET_CAMPAIGN_AUDIENCE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignAudience.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_MARKET_CAMPAIGN_DRAFT_STEPS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignDraftSteps.loading = LoadState.InProgress;
        draftState.marketCampaignDraftSteps.list = [];
      });
      return newState;
    }

    case FETCH_MARKET_CAMPAIGN_DRAFT_STEPS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignDraftSteps.loading = LoadState.Loaded;
        // Merge existing draft step data with the new data if it exists
        if (draftState.marketCampaignDraftSteps.data) {
          draftState.marketCampaignDraftSteps.data = {
            ...draftState.marketCampaignDraftSteps.data,
            ...data,
            draft_step_data: {
              ...(draftState.marketCampaignDraftSteps.data.draft_step_data ||
                {}),
              ...(data.draft_step_data || {}),
            },
          };
        } else {
          draftState.marketCampaignDraftSteps.data = data;
        }
      });
      return newState;
    }

    case FETCH_MARKET_CAMPAIGN_DRAFT_STEPS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignDraftSteps.loading = LoadState.Failed;
        draftState.marketCampaignDraftSteps.list = [];
      });
      return newState;
    }

    // Audience List Columns Reducers
    case FETCH_AUDIENCE_LIST_COLUMNS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.audienceListColumns.loading = LoadState.InProgress;
        draftState.audienceListColumns.data = null;
      });
      return newState;
    }
    case FETCH_AUDIENCE_LIST_COLUMNS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.audienceListColumns.loading = LoadState.Loaded;
        draftState.audienceListColumns.data = data;
      });
      return newState;
    }
    case FETCH_AUDIENCE_LIST_COLUMNS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.audienceListColumns.loading = LoadState.Failed;
        draftState.audienceListColumns.error =
          "Failed to fetch audience list columns";
      });
      return newState;
    }
    case UPSERT_AUDIENCE_LIST_COLUMN_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.audienceListColumns.loading = LoadState.InProgress;
      });
      return newState;
    }
    case UPSERT_AUDIENCE_LIST_COLUMN_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.audienceListColumns.loading = LoadState.Loaded;
        draftState.audienceListColumns.data = data;
      });
      return newState;
    }
    case UPSERT_AUDIENCE_LIST_COLUMN_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.audienceListColumns.loading = LoadState.Failed;
        draftState.audienceListColumns.error =
          "Failed to update audience list columns";
      });
      return newState;
    }

    // ############################################### Refactored Code ###############################################

    case FETCH_SINGLE_MARKET_CAMPAIGN_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.InProgress;
        draftState.marketCampainBasicInfo.data =
          initialMarketCampaignState["marketCampainBasicInfo"].data;
      });
      return newState;
    }
    case FETCH_SINGLE_MARKET_CAMPAIGN_SUCCESS: {
      const { data, draftStep } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.Loaded;
        draftState.marketCampainBasicInfo.data = data;
        draftState.marketCampaignDraftSteps.data = draftStep;
      });
      return newState;
    }
    case FETCH_SINGLE_MARKET_CAMPAIGN_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampainBasicInfo.loading = LoadState.Failed;
        draftState.marketCampainBasicInfo.error = errorMessage;
      });
      return newState;
    }

    // ############################################### CLEAR STATE ###############################################

    case CLEAR_MARKET_CAMPAIGN_STATE: {
      return initialMarketCampaignState;
    }

    case CLEAR_DRAFT_STEP_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampaignDraftSteps.data =
          initialMarketCampaignState.marketCampaignDraftSteps.data;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
